import moment from "moment";
import versoCall from "@/assets/images/canais/versocall.png";
import versoCommerce from "@/assets/images/canais/versocommerce.png";
import versoVendas from "@/assets/images/canais/versovendas.png";

export const MODAL_REGRA_NEGOCIO = "editRegraNegocio";
export const ITENS_POR_PAGINA = 12;
export const DEBOUNCE_BUSCA_MS = 300;

export const TIPOS_REGRA = [
  {
    chave: "P",
    label: "Promoção",
    icone: "tag",
    descricao: "Limita o percentual do pedido em produtos de promoção.",
  },
  {
    chave: "M",
    label: "Mix de Produto",
    icone: "cubes",
    descricao: "Exige quantidades mínimas e máximas de um mix de produtos.",
  },
  {
    chave: "MP",
    label: "Mix com percentual máximo",
    icone: "percent",
    descricao: "Limita o percentual do pedido em um mix de produtos.",
  },
  {
    chave: "D",
    label: "Dimensão",
    icone: "layer-group",
    descricao: "Exige proporção mínima e máxima entre segmentos de venda.",
  },
  // SP: {descricao: 'Script PHP'}, // DESABILITADO POR MOTIVOS DE SEGURANÇA
  {
    chave: "QS",
    label: "Query SQL",
    icone: "database",
    descricao: "Veta o pedido quando a consulta retornar resultado.",
  },
  {
    chave: "TF",
    label: "Taxa fixa da cobrança",
    icone: "file-invoice-dollar",
    descricao: "Cobra a taxa fixa da cobrança até um limite por período.",
  },
];

export const tipoRegra = (chave) => TIPOS_REGRA.find((tipo) => tipo.chave === chave) || null;

export const rotuloTipoRegra = (chave) => (tipoRegra(chave) || { label: "n/a" }).label;

export const PERIODOS_TAXA_FIXA = {
  DIA: "Por dia",
  SEMANA: "Por semana",
  MES: "Por mês",
};

export const BANCOS_QUERY = {
  LOCAL: "Banco de dados Versotech",
  ERP: "Banco de dados ERP",
};

export const CANAIS_REGRA_NEGOCIO = [
  { campo: "aplicab2b", label: "B2B", descricao: "Portal e loja virtual do cliente", imagem: versoCommerce },
  { campo: "aplicacallcenter", label: "Callcenter", descricao: "Pedidos digitados pelo operador", imagem: versoCall },
  { campo: "aplicafv", label: "Força de vendas", descricao: "Pedidos do representante", imagem: versoVendas },
];

export const canaisDaRegra = (regra) => CANAIS_REGRA_NEGOCIO.filter((canal) => !!regra[canal.campo]);

export const TIPOS_RESTRICAO = [
  { chave: "FILIAL", label: "Filial", rotuloCodigo: "Filial" },
  { chave: "CLIENTE", label: "Cliente", rotuloCodigo: "Cliente" },
  { chave: "REGIAO", label: "Região (Tabela de Preço)", rotuloCodigo: "Região" },
  { chave: "REGIAO_RCA", label: "Região (Representante)", rotuloCodigo: "Região" },
  { chave: "REDE", label: "Rede", rotuloCodigo: "Rede" },
  { chave: "PRACA", label: "Praça", rotuloCodigo: "Praça" },
  { chave: "ATIVIDADE", label: "Atividade", rotuloCodigo: "Atividade" },
  { chave: "REPRESENTANTE", label: "Representante", rotuloCodigo: "Representante" },
  { chave: "SUPERVISOR", label: "Supervisor", rotuloCodigo: "Supervisor" },
  { chave: "UF", label: "UF", rotuloCodigo: "UF" },
];

export const URL_OPCOES_RESTRICAO = "/admin/regras-negocio/restricoes/opcoes";

export const rotuloRestricao = (chave) => (TIPOS_RESTRICAO.find((tipo) => tipo.chave === chave) || { label: chave }).label;

export const MODOS_CONTAGEM_TAXA_FIXA = {
  COBRANCA: "Por cobrança",
  PEDIDO: "Por pedido enviado no período",
};

export const MODO_CONTAGEM_PADRAO = "COBRANCA";

export const MOMENTOS_CONTAGEM_TAXA_FIXA = {
  ENVIO: "No envio do pedido",
  FATURAMENTO: "No faturamento do pedido",
};

export const MOMENTO_CONTAGEM_PADRAO = "ENVIO";

export const TAXA_FIXA_PADRAO = () => ({
  cobrancas: [],
  limite_ocorrencias: 1,
  periodo_ocorrencias: "DIA",
  modo_contagem: MODO_CONTAGEM_PADRAO,
  momento_contagem: MOMENTO_CONTAGEM_PADRAO,
});

export const novaRegraNegocio = () => ({
  descricao: "",
  data_inicial: moment().format(),
  data_final: moment().add(1, "days").format(),
  perc_max_promocao: 0,
  perc_max_mix: 0,
  tipo: "P",
  produtos: [],
  dimensoes: [],
  promocoesExcessao: [],
  restricoes: [],
  //        DESABILITADO POR MOTIVOS DE SEGURANÇA
  // scriptPHP: {
  //   script: null
  // },
  querySQL: {
    query: null,
    banco: null,
  },
  taxaFixa: TAXA_FIXA_PADRAO(),
  aplicab2b: false,
  aplicacallcenter: false,
  aplicafv: false,
  ativo: true,
});

export const dataApi = (data) => (data ? moment(data).format("YYYY-MM-DD") : null);

export const formatarData = (data) => (data ? moment(data).format("DD/MM/YYYY") : null);

export function vigenciaRegra(regra) {
  const inicio = formatarData(regra.data_inicial);
  const fim = formatarData(regra.data_final);

  if (inicio && fim) return `${inicio} a ${fim}`;
  if (inicio) return `A partir de ${inicio}`;
  if (fim) return `Até ${fim}`;

  return "Sem prazo";
}

export function situacaoRegra(regra) {
  if (!regra.ativo) return { chave: "INATIVA", label: "Inativa" };

  const hoje = moment().format("YYYY-MM-DD");
  const inicio = dataApi(regra.data_inicial);
  const fim = dataApi(regra.data_final);

  if (fim && fim < hoje) return { chave: "ENCERRADA", label: "Encerrada" };
  if (inicio && inicio > hoje) return { chave: "AGENDADA", label: "Agendada" };

  return { chave: "VIGENTE", label: "Vigente" };
}
